import React from 'react';
import { Button, Text } from 'bench-internal-theme';
import { Modal } from 'modal-components';
import { ButtonLayout } from './DeleteContractorConfirmationModal.styles';

type DeleteContractorConfirmationModalProps = {
  closeModal: () => void;
  description?: string;
  onConfirm: () => void;
  title: string;
};

const DeleteContractorConfirmationModal = ({
  closeModal,
  onConfirm,
  title,
  description,
}: DeleteContractorConfirmationModalProps) => (
  <Modal>
    <Modal.Header title={title} onClose={closeModal} />
    <Modal.Body>
      {description && <Text>{description}</Text>}
      <ButtonLayout>
        <Button onClick={closeModal} styleType="ghost">
          Cancel
        </Button>
        <Button
          onClick={() => {
            closeModal();
            return onConfirm();
          }}
          aria-label="Confirm"
          styleType="primary"
          type="submit"
        >
          Confirm
        </Button>
      </ButtonLayout>
    </Modal.Body>
  </Modal>
);

export default DeleteContractorConfirmationModal;
